"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IcoFilledCircle = exports.IcoCircle = exports.IcoCaretRight = exports.IcoCaretLeft = exports.IcoCaretUp = exports.IcoCaretDown = exports.IcoChevronDoubleRightLight = exports.IcoChevronDoubleLeftLight = exports.IcoChevronDoubleUpLight = exports.IcoChevronDoubleDownLight = exports.IcoChevronRightLight = exports.IcoChevronLeftLight = exports.IcoChevronUpLight = exports.IcoChevronDownLight = exports.IcoChevronDoubleRight = exports.IcoChevronDoubleLeft = exports.IcoChevronDoubleUp = exports.IcoChevronDoubleDown = exports.IcoChevronRight = exports.IcoChevronLeft = exports.IcoChevronUp = exports.IcoChevronDown = exports.IcoMinus = exports.IcoExclamation = exports.IcoSyncAlt = exports.IcoCreditCard = exports.IcoSortAmountUp = exports.IcoSortAmountDown = exports.IcoFilter = exports.IcoStar = exports.IcoShapes = exports.IcoWind = exports.IcoCloudMoonRain = exports.IcoCloudRain = exports.IcoCloudShowersHeavy = exports.IcoCloudMoon = exports.IcoCloud = exports.IcoCloudSunRain = exports.IcoCloudSun = exports.IcoSun = exports.IcoEnvelope = exports.IcoMobileAlt = exports.IcoSort = exports.IcoLockOpen = exports.IcoLock = exports.IcoUser = exports.IcoThList = exports.IcoBinoculars = exports.IcoCogs = exports.IcoIdBadge = exports.IcoUsers = exports.IcoMap = exports.IcoGlobeAmericas = exports.IcoColumns = exports.IcoChartLine = exports.IcoChartBar = exports.IcoBan = exports.IcoExclamationCircle = exports.IcoInfoCircle = exports.IcoCalendar = exports.IcoProjectDiagram = exports.IcoClipboardList = exports.IcoClock = exports.IcoEye = exports.IcoFlag = exports.IcoThLarge = exports.IcoBolt = exports.IcoPalette = exports.IcoLayerGroup = exports.IcoThumbsUp = exports.IcoHistory = exports.IcoRocket = exports.IcoExclamationTriangle = exports.IcoTools = exports.IcoMapMarked = exports.IcoUserCog = exports.IcoBell = exports.IcoCrown = exports.IcoMoneyBillPayPro = exports.IcoMoneyBillPay = exports.IcoBars = exports.IcoDownload = exports.IcoExternalLinkAlt = exports.IcoCopy = exports.IcoTrashAlt = exports.IcoSearchPlus = exports.IcoSearch = exports.IcoFileAlt = exports.IcoCog = exports.IcoMapMarkerAlt = exports.IcoArrowsAlt = exports.IcoTimesLight = exports.IcoTimes = exports.IcoPencilAlt = exports.IcoRedoAlt = exports.IcoExpandArrowsAlt = exports.IcoCompressArrowsAlt = exports.IcoPlus = exports.IcoArrowRight = exports.IcoEllipsisV = void 0;
exports.IcoCrediCardRecurring = exports.IcoMapUser = exports.IcoCheckCircle = exports.IcoFourSquares = exports.IcoCheckFilledCircle = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faEllipsisV = require("@fortawesome/free-solid-svg-icons/faEllipsisV");

var _faArrowRight = require("@fortawesome/free-solid-svg-icons/faArrowRight");

var _faPlus = require("@fortawesome/free-solid-svg-icons/faPlus");

var _faTimes = require("@fortawesome/free-solid-svg-icons/faTimes");

var _faCompressArrowsAlt = require("@fortawesome/free-solid-svg-icons/faCompressArrowsAlt");

var _faExpandArrowsAlt = require("@fortawesome/free-solid-svg-icons/faExpandArrowsAlt");

var _faRedoAlt = require("@fortawesome/free-solid-svg-icons/faRedoAlt");

var _faPencilAlt = require("@fortawesome/free-solid-svg-icons/faPencilAlt");

var _faCaretDown = require("@fortawesome/free-solid-svg-icons/faCaretDown");

var _faCaretUp = require("@fortawesome/free-solid-svg-icons/faCaretUp");

var _faCaretLeft = require("@fortawesome/free-solid-svg-icons/faCaretLeft");

var _faCaretRight = require("@fortawesome/free-solid-svg-icons/faCaretRight");

var _faArrowsAlt = require("@fortawesome/free-solid-svg-icons/faArrowsAlt");

var _faMapMarker = require("@fortawesome/free-solid-svg-icons/faMapMarker");

var _faMapMarkerAlt = require("@fortawesome/free-solid-svg-icons/faMapMarkerAlt");

var _faMoneyBillWave = require("@fortawesome/free-solid-svg-icons/faMoneyBillWave");

var _faCog = require("@fortawesome/free-solid-svg-icons/faCog");

var _faFileAlt = require("@fortawesome/free-solid-svg-icons/faFileAlt");

var _faSearch = require("@fortawesome/free-solid-svg-icons/faSearch");

var _faSearchPlus = require("@fortawesome/free-solid-svg-icons/faSearchPlus");

var _faExternalLinkAlt = require("@fortawesome/free-solid-svg-icons/faExternalLinkAlt");

var _faDownload = require("@fortawesome/free-solid-svg-icons/faDownload");

var _faBars = require("@fortawesome/free-solid-svg-icons/faBars");

var _faCrown = require("@fortawesome/free-solid-svg-icons/faCrown");

var _faBell = require("@fortawesome/free-solid-svg-icons/faBell");

var _faUserCog = require("@fortawesome/free-solid-svg-icons/faUserCog");

var _faMapMarked = require("@fortawesome/free-solid-svg-icons/faMapMarked");

var _faTools = require("@fortawesome/free-solid-svg-icons/faTools");

var _faExclamationTriangle = require("@fortawesome/free-solid-svg-icons/faExclamationTriangle");

var _faRocket = require("@fortawesome/free-solid-svg-icons/faRocket");

var _faHistory = require("@fortawesome/free-solid-svg-icons/faHistory");

var _faLayerGroup = require("@fortawesome/free-solid-svg-icons/faLayerGroup");

var _faPalette = require("@fortawesome/free-solid-svg-icons/faPalette");

var _faBolt = require("@fortawesome/free-solid-svg-icons/faBolt");

var _faThLarge = require("@fortawesome/free-solid-svg-icons/faThLarge");

var _faFlag = require("@fortawesome/free-solid-svg-icons/faFlag");

var _faClipboardList = require("@fortawesome/free-solid-svg-icons/faClipboardList");

var _faProjectDiagram = require("@fortawesome/free-solid-svg-icons/faProjectDiagram");

var _faInfoCircle = require("@fortawesome/free-solid-svg-icons/faInfoCircle");

var _faExclamationCircle = require("@fortawesome/free-solid-svg-icons/faExclamationCircle");

var _faBan = require("@fortawesome/free-solid-svg-icons/faBan");

var _faChartBar = require("@fortawesome/free-solid-svg-icons/faChartBar");

var _faChartLine = require("@fortawesome/free-solid-svg-icons/faChartLine");

var _faColumns = require("@fortawesome/free-solid-svg-icons/faColumns");

var _faGlobeAmericas = require("@fortawesome/free-solid-svg-icons/faGlobeAmericas");

var _faUsers = require("@fortawesome/free-solid-svg-icons/faUsers");

var _faIdBadge = require("@fortawesome/free-solid-svg-icons/faIdBadge");

var _faCogs = require("@fortawesome/free-solid-svg-icons/faCogs");

var _faBinoculars = require("@fortawesome/free-solid-svg-icons/faBinoculars");

var _faThList = require("@fortawesome/free-solid-svg-icons/faThList");

var _faUser = require("@fortawesome/free-solid-svg-icons/faUser");

var _faLock = require("@fortawesome/free-solid-svg-icons/faLock");

var _faLockOpen = require("@fortawesome/free-solid-svg-icons/faLockOpen");

var _faSort = require("@fortawesome/free-solid-svg-icons/faSort");

var _faMobileAlt = require("@fortawesome/free-solid-svg-icons/faMobileAlt");

var _faSun = require("@fortawesome/free-solid-svg-icons/faSun");

var _faCloudSun = require("@fortawesome/free-solid-svg-icons/faCloudSun");

var _faCloudSunRain = require("@fortawesome/free-solid-svg-icons/faCloudSunRain");

var _faCloud = require("@fortawesome/free-solid-svg-icons/faCloud");

var _faCloudMoon = require("@fortawesome/free-solid-svg-icons/faCloudMoon");

var _faCloudShowersHeavy = require("@fortawesome/free-solid-svg-icons/faCloudShowersHeavy");

var _faCloudRain = require("@fortawesome/free-solid-svg-icons/faCloudRain");

var _faCloudMoonRain = require("@fortawesome/free-solid-svg-icons/faCloudMoonRain");

var _faWind = require("@fortawesome/free-solid-svg-icons/faWind");

var _faShapes = require("@fortawesome/free-solid-svg-icons/faShapes");

var _faStar = require("@fortawesome/free-solid-svg-icons/faStar");

var _faFilter = require("@fortawesome/free-solid-svg-icons/faFilter");

var _faSortAmountDown = require("@fortawesome/free-solid-svg-icons/faSortAmountDown");

var _faSortAmountUp = require("@fortawesome/free-solid-svg-icons/faSortAmountUp");

var _faSyncAlt = require("@fortawesome/free-solid-svg-icons/faSyncAlt");

var _faExclamation = require("@fortawesome/free-solid-svg-icons/faExclamation");

var _faMinus = require("@fortawesome/free-solid-svg-icons/faMinus");

var _faChevronDown = require("@fortawesome/free-solid-svg-icons/faChevronDown");

var _faChevronUp = require("@fortawesome/free-solid-svg-icons/faChevronUp");

var _faChevronLeft = require("@fortawesome/free-solid-svg-icons/faChevronLeft");

var _faChevronRight = require("@fortawesome/free-solid-svg-icons/faChevronRight");

var _faCopy = require("@fortawesome/free-solid-svg-icons/faCopy");

var _faCheck = require("@fortawesome/free-solid-svg-icons/faCheck");

var _faCircle = require("@fortawesome/free-solid-svg-icons/faCircle");

var _faCheckCircle = require("@fortawesome/free-solid-svg-icons/faCheckCircle");

var _faChevronDoubleDown = require("@fortawesome/pro-solid-svg-icons/faChevronDoubleDown");

var _faChevronDoubleUp = require("@fortawesome/pro-solid-svg-icons/faChevronDoubleUp");

var _faChevronDoubleLeft = require("@fortawesome/pro-solid-svg-icons/faChevronDoubleLeft");

var _faChevronDoubleRight = require("@fortawesome/pro-solid-svg-icons/faChevronDoubleRight");

var _faMoneyBillWave2 = require("@fortawesome/pro-solid-svg-icons/faMoneyBillWave");

var _faChevronDown2 = require("@fortawesome/pro-light-svg-icons/faChevronDown");

var _faChevronUp2 = require("@fortawesome/pro-light-svg-icons/faChevronUp");

var _faChevronLeft2 = require("@fortawesome/pro-light-svg-icons/faChevronLeft");

var _faChevronRight2 = require("@fortawesome/pro-light-svg-icons/faChevronRight");

var _faChevronDoubleDown2 = require("@fortawesome/pro-light-svg-icons/faChevronDoubleDown");

var _faChevronDoubleUp2 = require("@fortawesome/pro-light-svg-icons/faChevronDoubleUp");

var _faChevronDoubleLeft2 = require("@fortawesome/pro-light-svg-icons/faChevronDoubleLeft");

var _faChevronDoubleRight2 = require("@fortawesome/pro-light-svg-icons/faChevronDoubleRight");

var _faTimes2 = require("@fortawesome/pro-light-svg-icons/faTimes");

var _faTrashAlt = require("@fortawesome/free-regular-svg-icons/faTrashAlt");

var _faThumbsUp = require("@fortawesome/free-regular-svg-icons/faThumbsUp");

var _faEye = require("@fortawesome/free-regular-svg-icons/faEye");

var _faClock = require("@fortawesome/free-regular-svg-icons/faClock");

var _faCalendar = require("@fortawesome/free-regular-svg-icons/faCalendar");

var _faMap = require("@fortawesome/free-regular-svg-icons/faMap");

var _faEnvelope = require("@fortawesome/free-regular-svg-icons/faEnvelope");

var _faCircle2 = require("@fortawesome/free-regular-svg-icons/faCircle");

var _faSquare = require("@fortawesome/free-regular-svg-icons/faSquare");

var _faCreditCard = require("@fortawesome/free-regular-svg-icons/faCreditCard");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Create a private icon generator so we can have default props automatically added to each icon.


var IconGenerator = function IconGenerator(props) {
  var icon = props.icon,
      className = props.className,
      selected = props.selected,
      disabled = props.disabled,
      NewProps = _objectWithoutProperties(props, ["icon", "className", "selected", "disabled"]);

  var iconClassNames = (0, _classnames.default)('iconcomponent', className, {
    'iconcomponent--selected': selected,
    'iconcomponent--disabled': disabled
  });
  return _react.default.createElement(_reactFontawesome.FontAwesomeIcon, _extends({}, NewProps, {
    icon: icon,
    className: iconClassNames
  }));
};

IconGenerator.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool,
  icon: _propTypes.default.any.isRequired
};

var IcoEllipsisV = function IcoEllipsisV(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faEllipsisV.faEllipsisV
  }));
};

exports.IcoEllipsisV = IcoEllipsisV;
IcoEllipsisV.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoArrowRight = function IcoArrowRight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faArrowRight.faArrowRight
  }));
};

exports.IcoArrowRight = IcoArrowRight;
IcoArrowRight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoPlus = function IcoPlus(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faPlus.faPlus
  }));
};

exports.IcoPlus = IcoPlus;
IcoPlus.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCompressArrowsAlt = function IcoCompressArrowsAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCompressArrowsAlt.faCompressArrowsAlt
  }));
};

exports.IcoCompressArrowsAlt = IcoCompressArrowsAlt;
IcoCompressArrowsAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoExpandArrowsAlt = function IcoExpandArrowsAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faExpandArrowsAlt.faExpandArrowsAlt
  }));
};

exports.IcoExpandArrowsAlt = IcoExpandArrowsAlt;
IcoExpandArrowsAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoRedoAlt = function IcoRedoAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faRedoAlt.faRedoAlt
  }));
};

exports.IcoRedoAlt = IcoRedoAlt;
IcoRedoAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoPencilAlt = function IcoPencilAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faPencilAlt.faPencilAlt
  }));
};

exports.IcoPencilAlt = IcoPencilAlt;
IcoPencilAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoTimes = function IcoTimes(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faTimes.faTimes
  }));
};

exports.IcoTimes = IcoTimes;
IcoTimes.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoTimesLight = function IcoTimesLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faTimes2.faTimes
  }));
};

exports.IcoTimesLight = IcoTimesLight;
IcoTimesLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoArrowsAlt = function IcoArrowsAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faArrowsAlt.faArrowsAlt
  }));
};

exports.IcoArrowsAlt = IcoArrowsAlt;
IcoArrowsAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoMapMarkerAlt = function IcoMapMarkerAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMapMarkerAlt.faMapMarkerAlt
  }));
};

exports.IcoMapMarkerAlt = IcoMapMarkerAlt;
IcoMapMarkerAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCog = function IcoCog(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCog.faCog
  }));
};

exports.IcoCog = IcoCog;
IcoCog.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoFileAlt = function IcoFileAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faFileAlt.faFileAlt
  }));
};

exports.IcoFileAlt = IcoFileAlt;
IcoFileAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoSearch = function IcoSearch(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSearch.faSearch
  }));
};

exports.IcoSearch = IcoSearch;
IcoSearch.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoSearchPlus = function IcoSearchPlus(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSearchPlus.faSearchPlus
  }));
};

exports.IcoSearchPlus = IcoSearchPlus;
IcoSearchPlus.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoTrashAlt = function IcoTrashAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faTrashAlt.faTrashAlt
  }));
};

exports.IcoTrashAlt = IcoTrashAlt;
IcoTrashAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCopy = function IcoCopy(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCopy.faCopy
  }));
};

exports.IcoCopy = IcoCopy;
IcoCopy.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoExternalLinkAlt = function IcoExternalLinkAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faExternalLinkAlt.faExternalLinkAlt
  }));
};

exports.IcoExternalLinkAlt = IcoExternalLinkAlt;
IcoExternalLinkAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoDownload = function IcoDownload(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faDownload.faDownload
  }));
};

exports.IcoDownload = IcoDownload;
IcoDownload.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoBars = function IcoBars(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faBars.faBars
  }));
};

exports.IcoBars = IcoBars;
IcoBars.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoMoneyBillPay = function IcoMoneyBillPay(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMoneyBillWave.faMoneyBillWave
  }));
};

exports.IcoMoneyBillPay = IcoMoneyBillPay;
IcoMoneyBillPay.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoMoneyBillPayPro = function IcoMoneyBillPayPro(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMoneyBillWave2.faMoneyBillWave
  }));
};

exports.IcoMoneyBillPayPro = IcoMoneyBillPayPro;
IcoMoneyBillPayPro.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCrown = function IcoCrown(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCrown.faCrown
  }));
};

exports.IcoCrown = IcoCrown;
IcoCrown.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoBell = function IcoBell(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faBell.faBell
  }));
};

exports.IcoBell = IcoBell;
IcoBell.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoUserCog = function IcoUserCog(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faUserCog.faUserCog
  }));
};

exports.IcoUserCog = IcoUserCog;
IcoUserCog.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoMapMarked = function IcoMapMarked(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMapMarked.faMapMarked
  }));
};

exports.IcoMapMarked = IcoMapMarked;
IcoMapMarked.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoTools = function IcoTools(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faTools.faTools
  }));
};

exports.IcoTools = IcoTools;
IcoTools.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoExclamationTriangle = function IcoExclamationTriangle(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faExclamationTriangle.faExclamationTriangle
  }));
};

exports.IcoExclamationTriangle = IcoExclamationTriangle;
IcoExclamationTriangle.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoRocket = function IcoRocket(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faRocket.faRocket
  }));
};

exports.IcoRocket = IcoRocket;
IcoRocket.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoHistory = function IcoHistory(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faHistory.faHistory
  }));
};

exports.IcoHistory = IcoHistory;
IcoHistory.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoThumbsUp = function IcoThumbsUp(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faThumbsUp.faThumbsUp
  }));
};

exports.IcoThumbsUp = IcoThumbsUp;
IcoThumbsUp.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoLayerGroup = function IcoLayerGroup(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faLayerGroup.faLayerGroup
  }));
};

exports.IcoLayerGroup = IcoLayerGroup;
IcoLayerGroup.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoPalette = function IcoPalette(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faPalette.faPalette
  }));
};

exports.IcoPalette = IcoPalette;
IcoPalette.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoBolt = function IcoBolt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faBolt.faBolt
  }));
};

exports.IcoBolt = IcoBolt;
IcoBolt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoThLarge = function IcoThLarge(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faThLarge.faThLarge
  }));
};

exports.IcoThLarge = IcoThLarge;
IcoThLarge.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoFlag = function IcoFlag(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faFlag.faFlag
  }));
};

exports.IcoFlag = IcoFlag;
IcoFlag.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoEye = function IcoEye(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faEye.faEye
  }));
};

exports.IcoEye = IcoEye;
IcoEye.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoClock = function IcoClock(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faClock.faClock
  }));
};

exports.IcoClock = IcoClock;
IcoClock.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoClipboardList = function IcoClipboardList(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faClipboardList.faClipboardList
  }));
};

exports.IcoClipboardList = IcoClipboardList;
IcoClipboardList.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoProjectDiagram = function IcoProjectDiagram(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faProjectDiagram.faProjectDiagram
  }));
};

exports.IcoProjectDiagram = IcoProjectDiagram;
IcoProjectDiagram.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCalendar = function IcoCalendar(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCalendar.faCalendar
  }));
};

exports.IcoCalendar = IcoCalendar;
IcoCalendar.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoInfoCircle = function IcoInfoCircle(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faInfoCircle.faInfoCircle
  }));
};

exports.IcoInfoCircle = IcoInfoCircle;
IcoInfoCircle.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoExclamationCircle = function IcoExclamationCircle(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faExclamationCircle.faExclamationCircle
  }));
};

exports.IcoExclamationCircle = IcoExclamationCircle;
IcoExclamationCircle.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoBan = function IcoBan(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faBan.faBan
  }));
};

exports.IcoBan = IcoBan;
IcoBan.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChartBar = function IcoChartBar(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChartBar.faChartBar
  }));
};

exports.IcoChartBar = IcoChartBar;
IcoChartBar.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChartLine = function IcoChartLine(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChartLine.faChartLine
  }));
};

exports.IcoChartLine = IcoChartLine;
IcoChartLine.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoColumns = function IcoColumns(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faColumns.faColumns
  }));
};

exports.IcoColumns = IcoColumns;
IcoColumns.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoGlobeAmericas = function IcoGlobeAmericas(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faGlobeAmericas.faGlobeAmericas
  }));
};

exports.IcoGlobeAmericas = IcoGlobeAmericas;
IcoGlobeAmericas.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoMap = function IcoMap(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMap.faMap
  }));
};

exports.IcoMap = IcoMap;
IcoMap.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoUsers = function IcoUsers(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faUsers.faUsers
  }));
};

exports.IcoUsers = IcoUsers;
IcoUsers.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoIdBadge = function IcoIdBadge(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faIdBadge.faIdBadge
  }));
};

exports.IcoIdBadge = IcoIdBadge;
IcoIdBadge.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCogs = function IcoCogs(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCogs.faCogs
  }));
};

exports.IcoCogs = IcoCogs;
IcoCogs.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoBinoculars = function IcoBinoculars(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faBinoculars.faBinoculars
  }));
};

exports.IcoBinoculars = IcoBinoculars;
IcoBinoculars.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoThList = function IcoThList(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faThList.faThList
  }));
};

exports.IcoThList = IcoThList;
IcoThList.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoUser = function IcoUser(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faUser.faUser
  }));
};

exports.IcoUser = IcoUser;
IcoUser.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoLock = function IcoLock(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faLock.faLock
  }));
};

exports.IcoLock = IcoLock;
IcoLock.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoLockOpen = function IcoLockOpen(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faLockOpen.faLockOpen
  }));
};

exports.IcoLockOpen = IcoLockOpen;
IcoLockOpen.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoSort = function IcoSort(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSort.faSort
  }));
};

exports.IcoSort = IcoSort;
IcoSort.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoMobileAlt = function IcoMobileAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMobileAlt.faMobileAlt
  }));
};

exports.IcoMobileAlt = IcoMobileAlt;
IcoMobileAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoEnvelope = function IcoEnvelope(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faEnvelope.faEnvelope
  }));
};

exports.IcoEnvelope = IcoEnvelope;
IcoEnvelope.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoSun = function IcoSun(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSun.faSun
  }));
};

exports.IcoSun = IcoSun;
IcoSun.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCloudSun = function IcoCloudSun(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCloudSun.faCloudSun
  }));
};

exports.IcoCloudSun = IcoCloudSun;
IcoCloudSun.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCloudSunRain = function IcoCloudSunRain(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCloudSunRain.faCloudSunRain
  }));
};

exports.IcoCloudSunRain = IcoCloudSunRain;
IcoCloudSunRain.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCloud = function IcoCloud(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCloud.faCloud
  }));
};

exports.IcoCloud = IcoCloud;
IcoCloud.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCloudMoon = function IcoCloudMoon(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCloudMoon.faCloudMoon
  }));
};

exports.IcoCloudMoon = IcoCloudMoon;
IcoCloudMoon.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCloudShowersHeavy = function IcoCloudShowersHeavy(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCloudShowersHeavy.faCloudShowersHeavy
  }));
};

exports.IcoCloudShowersHeavy = IcoCloudShowersHeavy;
IcoCloudShowersHeavy.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCloudRain = function IcoCloudRain(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCloudRain.faCloudRain
  }));
};

exports.IcoCloudRain = IcoCloudRain;
IcoCloudRain.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCloudMoonRain = function IcoCloudMoonRain(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCloudMoonRain.faCloudMoonRain
  }));
};

exports.IcoCloudMoonRain = IcoCloudMoonRain;
IcoCloudMoonRain.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoWind = function IcoWind(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faWind.faWind
  }));
};

exports.IcoWind = IcoWind;
IcoWind.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoShapes = function IcoShapes(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faShapes.faShapes
  }));
};

exports.IcoShapes = IcoShapes;
IcoShapes.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoStar = function IcoStar(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faStar.faStar
  }));
};

exports.IcoStar = IcoStar;
IcoStar.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoFilter = function IcoFilter(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faFilter.faFilter
  }));
};

exports.IcoFilter = IcoFilter;
IcoFilter.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoSortAmountDown = function IcoSortAmountDown(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSortAmountDown.faSortAmountDown
  }));
};

exports.IcoSortAmountDown = IcoSortAmountDown;
IcoSortAmountDown.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoSortAmountUp = function IcoSortAmountUp(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSortAmountUp.faSortAmountUp
  }));
};

exports.IcoSortAmountUp = IcoSortAmountUp;
IcoSortAmountUp.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCreditCard = function IcoCreditCard(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCreditCard.faCreditCard
  }));
};

exports.IcoCreditCard = IcoCreditCard;
IcoCreditCard.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoSyncAlt = function IcoSyncAlt(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSyncAlt.faSyncAlt
  }));
};

exports.IcoSyncAlt = IcoSyncAlt;
IcoSyncAlt.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoExclamation = function IcoExclamation(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faExclamation.faExclamation
  }));
};

exports.IcoExclamation = IcoExclamation;
IcoExclamation.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoMinus = function IcoMinus(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMinus.faMinus
  }));
};

exports.IcoMinus = IcoMinus;
IcoMinus.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDown = function IcoChevronDown(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDown.faChevronDown
  }));
};

exports.IcoChevronDown = IcoChevronDown;
IcoChevronDown.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronUp = function IcoChevronUp(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronUp.faChevronUp
  }));
};

exports.IcoChevronUp = IcoChevronUp;
IcoChevronUp.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronLeft = function IcoChevronLeft(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronLeft.faChevronLeft
  }));
};

exports.IcoChevronLeft = IcoChevronLeft;
IcoChevronLeft.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronRight = function IcoChevronRight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronRight.faChevronRight
  }));
};

exports.IcoChevronRight = IcoChevronRight;
IcoChevronRight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDoubleDown = function IcoChevronDoubleDown(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDoubleDown.faChevronDoubleDown
  }));
};

exports.IcoChevronDoubleDown = IcoChevronDoubleDown;
IcoChevronDoubleDown.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDoubleUp = function IcoChevronDoubleUp(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDoubleUp.faChevronDoubleUp
  }));
};

exports.IcoChevronDoubleUp = IcoChevronDoubleUp;
IcoChevronDoubleUp.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDoubleLeft = function IcoChevronDoubleLeft(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDoubleLeft.faChevronDoubleLeft
  }));
};

exports.IcoChevronDoubleLeft = IcoChevronDoubleLeft;
IcoChevronDoubleLeft.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDoubleRight = function IcoChevronDoubleRight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDoubleRight.faChevronDoubleRight
  }));
};

exports.IcoChevronDoubleRight = IcoChevronDoubleRight;
IcoChevronDoubleRight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDownLight = function IcoChevronDownLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDown2.faChevronDown
  }));
};

exports.IcoChevronDownLight = IcoChevronDownLight;
IcoChevronDownLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronUpLight = function IcoChevronUpLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronUp2.faChevronUp
  }));
};

exports.IcoChevronUpLight = IcoChevronUpLight;
IcoChevronUpLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronLeftLight = function IcoChevronLeftLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronLeft2.faChevronLeft
  }));
};

exports.IcoChevronLeftLight = IcoChevronLeftLight;
IcoChevronLeftLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronRightLight = function IcoChevronRightLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronRight2.faChevronRight
  }));
};

exports.IcoChevronRightLight = IcoChevronRightLight;
IcoChevronRightLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDoubleDownLight = function IcoChevronDoubleDownLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDoubleDown2.faChevronDoubleDown
  }));
};

exports.IcoChevronDoubleDownLight = IcoChevronDoubleDownLight;
IcoChevronDoubleDownLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDoubleUpLight = function IcoChevronDoubleUpLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDoubleUp2.faChevronDoubleUp
  }));
};

exports.IcoChevronDoubleUpLight = IcoChevronDoubleUpLight;
IcoChevronDoubleUpLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDoubleLeftLight = function IcoChevronDoubleLeftLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDoubleLeft2.faChevronDoubleLeft
  }));
};

exports.IcoChevronDoubleLeftLight = IcoChevronDoubleLeftLight;
IcoChevronDoubleLeftLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoChevronDoubleRightLight = function IcoChevronDoubleRightLight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faChevronDoubleRight2.faChevronDoubleRight
  }));
};

exports.IcoChevronDoubleRightLight = IcoChevronDoubleRightLight;
IcoChevronDoubleRightLight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCaretDown = function IcoCaretDown(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCaretDown.faCaretDown
  }));
};

exports.IcoCaretDown = IcoCaretDown;
IcoCaretDown.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCaretUp = function IcoCaretUp(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCaretUp.faCaretUp
  }));
};

exports.IcoCaretUp = IcoCaretUp;
IcoCaretUp.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCaretLeft = function IcoCaretLeft(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCaretLeft.faCaretLeft
  }));
};

exports.IcoCaretLeft = IcoCaretLeft;
IcoCaretLeft.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCaretRight = function IcoCaretRight(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCaretRight.faCaretRight
  }));
};

exports.IcoCaretRight = IcoCaretRight;
IcoCaretRight.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCircle = function IcoCircle(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCircle2.faCircle
  }));
};

exports.IcoCircle = IcoCircle;
IcoCircle.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoFilledCircle = function IcoFilledCircle(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCircle.faCircle
  }));
};

exports.IcoFilledCircle = IcoFilledCircle;
IcoFilledCircle.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCheckFilledCircle = function IcoCheckFilledCircle(props) {
  return _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCheckCircle.faCheckCircle
  }));
}; // custom icons:


exports.IcoCheckFilledCircle = IcoCheckFilledCircle;
IcoCheckFilledCircle.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoFourSquares = function IcoFourSquares(props) {
  var SquareSize = 7;
  var SquareSpacing = 1;
  var SquareMovePlus = Math.floor(SquareSize / 2) + SquareSpacing;
  var SquareMoveNega = SquareMovePlus * -1;
  return _react.default.createElement("span", {
    className: "fa-layers fa-fw"
  }, _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSquare.faSquare,
    transform: {
      size: SquareSize,
      x: SquareMoveNega,
      y: SquareMoveNega
    }
  })), _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSquare.faSquare,
    transform: {
      size: SquareSize,
      x: SquareMoveNega,
      y: SquareMovePlus
    }
  })), _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSquare.faSquare,
    transform: {
      size: SquareSize,
      x: SquareMovePlus,
      y: SquareMoveNega
    }
  })), _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSquare.faSquare,
    transform: {
      size: SquareSize,
      x: SquareMovePlus,
      y: SquareMovePlus
    }
  })));
};

exports.IcoFourSquares = IcoFourSquares;
IcoFourSquares.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCheckCircle = function IcoCheckCircle(props) {
  return _react.default.createElement("span", {
    className: "fa-layers fa-fw"
  }, _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCircle2.faCircle,
    transform: {
      x: 0,
      y: 0
    }
  })), _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCheck.faCheck,
    transform: {
      size: 10,
      x: 0,
      y: 0
    }
  })));
};

exports.IcoCheckCircle = IcoCheckCircle;
IcoCheckCircle.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoMapUser = function IcoMapUser(props) {
  var UserSize = 14;
  var MapMarkerSize = UserSize * 0.7;
  var MapMarkerAltSize = MapMarkerSize * 0.7;
  var MapMarkerPositionX = MapMarkerSize / 2;
  var MapMarkerPositionY = MapMarkerSize / 2.5;
  return _react.default.createElement("span", {
    className: "fa-layers fa-fw"
  }, _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faUser.faUser,
    transform: {
      size: UserSize,
      x: 0,
      y: 0
    }
  })), _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMapMarker.faMapMarker,
    style: {
      color: '#fff'
    },
    transform: {
      size: MapMarkerSize,
      x: MapMarkerPositionX,
      y: MapMarkerPositionY
    }
  })), _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faMapMarkerAlt.faMapMarkerAlt,
    transform: {
      size: MapMarkerAltSize,
      x: MapMarkerPositionX,
      y: MapMarkerPositionY
    }
  })));
};

exports.IcoMapUser = IcoMapUser;
IcoMapUser.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};

var IcoCrediCardRecurring = function IcoCrediCardRecurring(props) {
  var CCSize = 14;
  var RecurringWhiteSize = CCSize * 0.8;
  var RecurringSize = RecurringWhiteSize * 0.7;
  var RecurringPositionX = RecurringSize / 1.45;
  var RecurringPositionY = RecurringSize / 1.45;
  return _react.default.createElement("span", {
    className: "fa-layers fa-fw"
  }, _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCreditCard.faCreditCard,
    transform: {
      size: CCSize,
      x: 0,
      y: 0
    }
  })), _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faCircle.faCircle,
    style: {
      color: '#fff'
    },
    transform: {
      size: RecurringWhiteSize,
      x: RecurringPositionX,
      y: RecurringPositionY
    }
  })), _react.default.createElement(IconGenerator, _extends({}, props, {
    icon: _faSyncAlt.faSyncAlt,
    transform: {
      size: RecurringSize,
      x: RecurringPositionX,
      y: RecurringPositionY
    }
  })));
};

exports.IcoCrediCardRecurring = IcoCrediCardRecurring;
IcoCrediCardRecurring.propTypes = {
  className: _propTypes.default.any,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  value: _propTypes.default.string,
  mask: _propTypes.default.any,
  size: _propTypes.default.any,
  color: _propTypes.default.string,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  border: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  listItem: _propTypes.default.bool,
  flip: _propTypes.default.any,
  pull: _propTypes.default.any,
  rotation: _propTypes.default.any,
  transform: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.any]),
  symbol: _propTypes.default.any,
  style: _propTypes.default.any,
  tabIndex: _propTypes.default.number,
  title: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool
};